import { Component } from '@verndale/core';
import debounce from 'lodash/debounce';
import { html } from '../helpers/html';

const PROPS = ['filter', 'render', 'value'];
const ARROW_LEFT = 37;
const ARROW_UP = 38;
const ARROW_RIGHT = 39;
const ARROW_DOWN = 40;
const ENTER = 13;
const TAB = 9;
const SHIFT = 16;
const KEYS = [ARROW_LEFT, ARROW_UP, ARROW_RIGHT, ARROW_DOWN, ENTER, TAB, SHIFT];
const SPINNER = `
  <div class="autocomplete__spinner">
    <div class="spinner">
      <svg>
        <use xlink:href="#spinner-of-dots"></use>
      </svg>
    </div>
  </div>
`;

class Autocomplete extends Component {
  setupDefaults() {
    this.ready = this.validateConfig();

    if (this.ready) {
      this.dom = {
        $document: $(document),
        $input: this.$el.find('.autocomplete__input'),
        $list: this.$el.find('.autocomplete__list')
      };

      this.$el.append(SPINNER);

      this.dom = {
        $spinner: this.$el.find('.spinner')
      };

      this.resetItems();
    }
  }

  addListeners() {
    if (this.ready) {
      this.dom.$input.on('keydown', ::this.handleKeypress);
      this.dom.$input.on('keyup', debounce(::this.handleKeyup, 50));
      this.dom.$list.on('click', '.autocomplete__item', ::this.handleClick);
      this.dom.$list.on(
        'mouseenter',
        '.autocomplete__item',
        ::this.handleMouseEnter
      );
      this.dom.$document.on('click', ::this.handleClickOutside);
    }
  }

  handleKeypress(e) {
    switch (e.keyCode) {
    case ARROW_UP:
      this.prevItem();
      return false;
    case ARROW_DOWN:
      this.nextItem();
      return false;
    case ENTER:
      this.selectItem();
      return false;
    default:
      return true;
    }
  }

  async handleKeyup(e) {
    if (KEYS.indexOf(parseInt(e.keyCode, 10)) < 0) {
      try {
        this.$el.addClass('loading');
        this.dom.$spinner.addClass('is-active');
        this.data = await this.getData(e.currentTarget.value);
        this.renderItems();
      } catch (error) {
        console.error(error);
      }
      this.$el.removeClass('loading');
      this.dom.$spinner.removeClass('is-active');
    }
  }

  handleClick(e) {
    const $item = $(e.currentTarget);
    const index = this.dom.$list.children().index($item);
    this.activeIndex = index;
    this.selectItem();
  }

  getData(value) {
    return this.props.filter(value);
  }

  resetItems() {
    this.closeList();
    this.dom.$list.empty();
    this.selectedIndex = -1;
    this.activeIndex = -1;
  }

  renderItems() {
    this.resetItems();

    if (!Array.isArray(this.data)) {
      return;
    }

    const items = this.data.map(
      item => html`
        <li class="autocomplete__item">${this.props.render(item)}</li>
      `
    );

    if (items.length) {
      this.openList();
    }
    this.dom.$list.html(items.join(''));
  }

  prevItem() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    } else {
      this.activeIndex = this.dom.$list.children().length - 1;
    }
    this.setActiveItem(this.activeIndex);
  }

  nextItem() {
    if (this.activeIndex < this.dom.$list.children().length - 1) {
      this.activeIndex++;
    } else {
      this.activeIndex = 0;
    }
    this.setActiveItem(this.activeIndex);
  }

  setActiveItem(index) {
    const $items = this.dom.$list.children();
    const $item = $items.eq(index);
    $items.removeClass('autocomplete__item--active');
    $item.addClass('autocomplete__item--active');

    const itemHeight = $item.outerHeight();
    const scrollTop = this.dom.$list.scrollTop();
    const viewport = scrollTop + this.dom.$list.outerHeight();
    const offset = itemHeight * index;

    if (offset < scrollTop || offset + itemHeight > viewport) {
      this.dom.$list.scrollTop(offset);
    }
  }

  handleMouseEnter(e) {
    const $item = $(e.currentTarget);
    const index = this.dom.$list.children().index($item);
    this.setActiveItem(index);
  }

  selectItem() {
    const $items = this.dom.$list.children();
    const item = this.data[this.activeIndex];
    const value = this.props.value(item);
    this.selectedIndex = this.activeIndex;

    $items.removeClass('autocomplete__item--active');
    this.dom.$input.val(value);
    this.dom.$input.focus();
    this.closeList();
  }

  getSelectedItem() {
    if (this.selectedIndex < 0) {
      return null;
    }
    const item = this.data[this.selectedIndex];
    if (!item) {
      return null;
    }
    return item.item;
  }

  setSelectedItem(item) {
    const value = this.props.value(item);

    this.resetItems();
    this.selectedIndex = 0;
    this.data = [item];
    this.dom.$input.val(value);
    // this.dom.$input.focus();
    this.closeList();
  }

  openList() {
    this.dom.$list.addClass('autocomplete__list--active');
  }

  closeList() {
    this.dom.$list.removeClass('autocomplete__list--active');
  }

  handleClickOutside(e) {
    if (!$(e.target).closest(this.$el).length) {
      this.closeList();
    }
  }

  validateConfig() {
    const missingProp = PROPS.filter(key => !this.props[key]);
    if (missingProp.length) {
      console.error(`Autocomponent - ${missingProp} must be defined`);
    }
    return true;
  }
}

export default Autocomplete;
